'use server'

import { getServerSession } from 'next-auth'

import { authOptions } from '@/libs/auth'

export default async function getAuthToken(refresh = false) {
  try {
    const session = await getServerSession(authOptions)

    const authToken = refresh
      ? { token: session?.user?.refresh_token, error: session?.error }
      : session?.user?.access_token

    if (!authToken) {
      console.warn('No token found in session', { refresh, session })

      return null
    }

    return authToken
  } catch (error) {
    console.error('Error retrieving auth token:', error)

    return null
  }
}
